module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/183-hong-kong-2ff58126a70e919279d71f17585d1f94.svg";